import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Notify } from 'notiflix/build/notiflix-notify-aio';
import { useGoogleReCaptcha } from '@google-recaptcha/react';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';
import feedbackSelectors from '@/redux/feedback/feedbackSelectors';

import { setFeedbackStatus } from '@/redux/feedback/feedbackSlice';
import { setDisplayModal } from '@/redux/app/appSlice';

import feedbackOperations from '@/redux/feedback/feedbackOperations';

import image from '@/images/modalFeedback/send-success.webp';

import Modal from '@/ui/modal';
import Input from '@/ui/input';
import Textarea from '@/ui/textarea';

import s from './modalFeedback.module.css';

function ModalFeedback({ close }) {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const status = useSelector(feedbackSelectors.status);

  const { executeV3 } = useGoogleReCaptcha();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [text, setText] = useState('');

  const [recaptchaToken, setRecaptchaToken] = useState('');
  console.log('Recaptcha token:', recaptchaToken);

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeV3) {
      console.log('Execute recaptcha not available');
      return;
    }

    const token = await executeV3();

    setRecaptchaToken(token);
  }, [executeV3]);

  const closeModal = () => {
    dispatch(setFeedbackStatus(null));
    dispatch(setDisplayModal(false));

    close();
  };

  const handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    if (!recaptchaToken) {
      Notify.warning('Google recaptcha is required');
      return;
    }

    if (!name) {
      Notify.warning(i18n.Введите_ваше_имя);
      return;
    }

    if (!email) {
      Notify.warning(i18n.Введите_ваш_email);
      return;
    }

    if (!text) {
      Notify.warning(i18n.Введите_ваш_текст);
      return;
    }

    const data = {
      name,
      email,
      text,
    };

    dispatch(feedbackOperations.requestFeeback(data));
  };

  // You can use useEffect to trigger the verification as soon as the component being loaded
  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  return (
    <Modal close={close}>
      {status === 'success' ? (
        <>
          <img src={image} alt="success" className={s.img} />
          <p className={s.title}>{i18n.успешно}</p>
          <p className={s.text}>{i18n.Ваша_заявка_принята}.</p>
          <button type="button" onClick={closeModal} className={s.btn_ok}>
            {i18n.закрыть}
          </button>
        </>
      ) : (
        <>
          <p className={s.title}>{i18n.написать_нам}</p>
          <form onSubmit={handleSubmit} className={s.form}>
            <Input
              id="feedbackInputName"
              placeholder={i18n.имя}
              value={name}
              onChange={setName}
            />
            <Input
              type="email"
              id="feedbackInputEmail"
              placeholder="e-mail"
              value={email}
              onChange={setEmail}
            />
            <Textarea
              id="feedbackInputText"
              placeholder={i18n.текст_сообщения}
              value={text}
              onChange={setText}
            />
            <button type="submit" className={s.btn_ok}>
              {i18n.отправить}
            </button>
          </form>
        </>
      )}
    </Modal>
  );
}

export default ModalFeedback;

ModalFeedback.propTypes = {
  close: PropTypes.func.isRequired,
};
